module.exports = "<p>\r\n  settings works!\r\n</p>\r\n"